<div #menuDocument>
  <kendo-tabstrip >
    <kendo-tabstrip-tab [title]="'SESSION'" [selected]="true">
      <ng-template kendoTabContent>
        <kendo-treeview
          [nodes]="data"
          textField="text"
          kendoTreeViewExpandable
          kendoTreeViewSelectable
          kendoTreeViewHierarchyBinding
          childrenField="items"
        >
        </kendo-treeview>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab [title]="'PRODUIT'">
      <ng-template kendoTabContent>
        <kendo-treeview
          [nodes]="data"
          textField="text"
          kendoTreeViewExpandable
          kendoTreeViewSelectable
          kendoTreeViewHierarchyBinding
          childrenField="items"
        >
        </kendo-treeview>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab [title]="'CLIENT'">
      <ng-template kendoTabContent>
        <kendo-treeview
          [nodes]="data"
          textField="text"
          kendoTreeViewExpandable
          kendoTreeViewSelectable
          kendoTreeViewHierarchyBinding
          childrenField="items"
        >
        </kendo-treeview>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab [title]="'APPRENANT'">
      <ng-template kendoTabContent>
        <kendo-treeview
          [nodes]="data"
          textField="text"
          kendoTreeViewExpandable
          kendoTreeViewSelectable
          kendoTreeViewHierarchyBinding
          childrenField="items"
        >
        </kendo-treeview>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab [title]="'MON  COMPTE'">
      <ng-template kendoTabContent>
        <kendo-treeview
          [nodes]="data"
          textField="text"
          kendoTreeViewExpandable
          kendoTreeViewSelectable
          kendoTreeViewHierarchyBinding
          childrenField="items"
        >
        </kendo-treeview>
      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
</div>
